module.exports = __webpack_public_path__ + "static/media/KCS.f9a918b5.svg";